angular.module("AccountingBoxApp").config(function($stateProvider) {
  $stateProvider
    .state("app.company.bank", {
      abstract: true,
      template: "<ui-view/>",
      url: "/bank",
      controller: "BankCtrl"
    })
    .state('app.company.bank.accounts', {
      url: '',
      template: ''
    })
    .state('app.company.bank.transactions2', {
      url: '/transactions/:accountId',
      template: ''
    })
    .state("app.company.bank.rules", {
      url: "/rules",
      templateUrl: "app/bank/rules/rules.html",
      controller: "BankRulesCtrl",
      controllerAs: "br"
    })
    .state("app.company.bank.rules.edit", {
      url: "/rules/edit",
      templateUrl: "app/bank/rules/edit/edit.html",
      controller: "EditBankRulesCtrl",
      controllerAs: "ebr"
    })
    .state("app.company.bank.transactions", {
      url: "/:id",
      templateUrl: "app/bank/transactions/transactions.html",
      controller: "BankTransactionsCtrl",
      controllerAs: "bt",
      params: {
        bankAccount: null
      }
    })

});
angular
  .module("AccountingBoxApp")
  .controller("BankCtrl", function($scope, $rootScope) {
    $scope.bankAccountTypes = {
      checking_account: "Betaalrekening",
      savings_account: "Spaarrekening"
    };
    if ($rootScope.currentCompany.admin) {
      $scope.bankAccountTypes.sepa_account = "SEPA Incasso";
    }

    $scope.bankHomepage = function(bankAccount) {
      var link = "";
      var homepage = "";
      var bN = bankAccount.bankName;
      var t = bankAccount.bankType;
      if (bN === "SNS Bank" && t === "private") {
        homepage = "www.snsbank.nl";
      }
      if (bN === "SNS Bank" && t === "business") {
        homepage = "www.snsbank.nl";
      }
      if (bN === "Rabobank") {
        homepage = "www.rabobank.nl";
      }
      if (bN === "ASN Bank" && t === "private") {
        homepage = "www.asnbank.nl";
      }
      if (bN === "ASN Bank" && t === "business") {
        homepage = "www.asnbank.nl";
      }
      if (bN === "Knab") {
        homepage = "www.knab.nl";
      }
      if (bN === "Triodos Bank") {
        homepage = "www.triodos.nl";
      }
      if (bN === "Van Lanschot") {
        homepage = "www.vanlanschot.nl";
      }
      if (bN === "Bunq") {
        homepage = "www.bunq.nl";
      }

      if (bN === "ABN AMRO") {
        homepage = "www.abnamro.nl";
      }
      if (bN === "ING") {
        homepage = "www.ing.nl";
      }
      if (bN === "RegioBank") {
        homepage = "www.regiobank.nl";
      }
      if (bN === "Mollie") {
        homepage = "www.mollie.nl";
      }
      if (bN === "Moneyou") {
        homepage = "www.moneyou.nl";
      }

      //return logo url:
      return "https://logo.accountingbox.nl?website=" + homepage;
    };
  });
